import React from 'react';
import { useNavigate } from 'react-router-dom';
import programs from '../../data/programs';

function ProgrammesGrid() {
  const navigate = useNavigate();
  return (
    <div className="flex -mx-2 flex-wrap mt-5 gap-y-4 md:gap-8 ">
      {programs.map((item, index) => (
        <div className="p-2 w-1/2 sm:w-1/3 md:w-1/4 flex" key={item.name}>
          {index === 6 || index === 5 ? (
            <button
              type="button"
              onClick={() => navigate(item.link)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') navigate(item.link);
              }}
              className="w-full h-full cursor-pointer border p-1.5 relative"
            >
              <div className="flex w-full h-[calc(100%-30px)] justify-center items-center py-12">
                <img src={item.img} alt={item.name} className="" />
              </div>
              <p className="w-full text-xs text-center absolute left-0 bottom-2.5">
                {item.name}
              </p>
            </button>
          ) : (
            <a
              href={item.link}
              target="_blank"
              rel="noreferrer"
              className="w-full h-full"
            >
              <div className="border p-1.5 w-full h-full relative">
                <div className="flex w-full h-[calc(100%-30px)] justify-center items-center py-12">
                  <img src={item.img} alt={item.name} className="" />
                </div>
                <p className="w-full text-xs text-center absolute left-0 bottom-2.5">
                  {item.name}
                </p>
              </div>
            </a>
          )}
        </div>
      ))}
    </div>
  );
}

export default ProgrammesGrid;
